import { useQuery } from 'react-query';
import { SiteSetting } from 'v2/models';
import restFactory from 'v2/utils/restFactory';

export const useSiteSettings = () => {
  return useQuery('SiteSettings', () =>
    restFactory.get<SiteSetting>('/dj/api/v1/site-settings')
  );
};
